
var $cache = {
    body: $('body'),
};
// Add click event for minus button
$cache.body.on('click', '.custom-quantity-selector .minus', function() {
    var $input = $(this).parent().find('input');
    updateQuantity(-1, $input);
});

// Add click event for plus button
$cache.body.on('click', '.custom-quantity-selector .plus', function() {
    var $input = $(this).parent().find('input');
    updateQuantity(1, $input);
});

// Add input event for direct input
$cache.body.on('input', '.custom-quantity-selector input', function() {
    var $input = $(this).parent().find('input');
    updateQuantity(0, $input);
});

// Function to update quantity
function updateQuantity(change, $input) {
    let currentValue = parseInt($input.val()) || 0;
    currentValue += change;

    // Ensure the value is within the min and max limits
    const min = parseInt($input.attr('min')) || 1;
    const max = parseInt($input.attr('max'));
    currentValue = Math.min(Math.max(currentValue, min), max);

    // Update the input value
    // Get all input fields with the same name as $input
    var $inputs = $('input[name="' + $input.attr('name') + '"]');
    $inputs.val(currentValue);
    $input.val(currentValue);
    if (max == 0) {
        return
    }
    $input.trigger('change');
}

$(() => {
    const stuckClass = 'is-stuck';
    const $stickyTopElements = $('.sticky-top');
    const $stickyBottomElements = $('.sticky-bottom');
    const determineSticky = () => {
      $stickyTopElements.each((i, el) => {
        const $el = $(el);
        const stickPoint = parseInt($el.css('top'), 10);
        const currTop = el.getBoundingClientRect().top;
        const isStuck = currTop <= stickPoint;
        $el.toggleClass(stuckClass, isStuck);
        $('.whatsapp-float').toggleClass('d-none', isStuck);
      });
      $stickyBottomElements.each((i, el) => {
        const $el = $(el);
        const stickPoint = parseInt($el.css('bottom'), 10);
        const currBottom = el.getBoundingClientRect().bottom;
        const isStuck = currBottom + stickPoint >= window.innerHeight;
        $el.toggleClass(stuckClass, isStuck);
        $('.whatsapp-float').toggleClass('d-none', isStuck);
      });
    };
    //run immediately
    determineSticky();
    //Run when the browser is resized or scrolled
    //Uncomment below to run less frequently with a debounce
    //let debounce = null;
    $(window).on('resize scroll', () => {
      //clearTimeout(debounce);
      //debounce = setTimeout(determineSticky, 100);
      determineSticky();
    });
  });